if (!customElements.get('splide-carousel')) {
	class SplideCarousel extends HTMLElement {
		constructor() {
            super();
            this.carousel = "";
            this.splideCarousel = "";
		}
		connectedCallback() {
            console.log('func running on splide');

            this.carousel = this.querySelector('.splide') ?? "";
            
            if (Splide && this.carousel) {
                this.splideCarousel = new Splide(this.carousel).mount();

                const parent = this.closest('.socials-gallery-container') ?? "";

                if (parent) {
                    const back = parent.querySelector('.back-button') ?? "";
                    const forward = parent.querySelector('.forward-button') ?? "";

                    if (back) {
                        back.addEventListener('click', (e) => {
                            this.splideCarousel.go('<');
                        });
                    }

                    if (forward) {
                        forward.addEventListener('click', (e) => {
                            this.splideCarousel.go('>');
                        });
                    }
                }
                console.log(parent, 'parent el?');
            }

		}
	}
	customElements.define('splide-carousel', SplideCarousel);
}
